module.exports = __webpack_public_path__ + "img/sass.3286476a.png";